import TakerSummaryPie from "pages/PanelPage/components/charts/TakerSummaryPie/TakerSummaryPie";

export default TakerSummaryPie;
